export * from 'server/models/BerthRelevance';


// WEBPACK FOOTER //
// ./data/models/BerthRelevance.ts